import { TYPES } from "./draft_dialog.type";
import lodash from "lodash";
import {
  doc,
  limit,
  onSnapshot,
  query,
  where,
  orderBy,
} from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApiFunctions } from "store/bailiff/api";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getApp } from "firebase/app";
import moment from "moment";

const COLOR_SPEAKER = [
  "#3B82F6", // Blue (Speaker 1 trong ảnh)
  "#EF4444", // Red (Speaker 2 trong ảnh)
  "#10B981", // Emerald (Xanh lá)
  "#F59E0B", // Amber (Vàng cam)
  "#8B5CF6", // Violet (Tím)
  "#EC4899", // Pink (Hồng)
  "#06B6D4", // Cyan (Xanh lơ)
  "#F97316", // Orange (Cam đậm)
  "#6366F1", // Indigo (Xanh tím)
  "#14B8A6", // Teal (Xanh mòng két)
  "#79d7fd", // Persona 3 Blue
  "#00BBFA", // Persona 3 Darker Blue
  "#FAA622", // Persona 4 Orange
  "#FFE52C", // Persona 4 Yellow
  "#0D0D0D", // Persona 5 Black
  "#D92323", // Persona 5 Red
];

// ========= firebase function =========//
const bucket = "gs://vi-viet-nam-bailiff-draft";
const app = getApp();
const storage = getStorage(app, bucket);

//snap all provider
const allDraftDialogSub = [];
export const snapDraftDialog =
  ({ bailiffId, tab }, callback) =>
  (dispatch) => {
    setDraftDialogAllSuccess(dispatch, null);
    setDraftDialogMergeRawSuccess(dispatch, []);
    setDraftDialogSpeakersRawSuccess(dispatch, []);
    const cRef = getRefs().dialog;
    const rated = tab === "not_edit" ? false : true;
    const c0 = where("bailiff", "==", bailiffId);
    const c2 = orderBy("slot", "asc");
    let qRef = query(cRef, c0, c2);

    if (tab === "edit") {
      const c1 = where("rated", "==", rated);
      qRef = query(cRef, c0, c1, c2);
    }

    if (tab === "not_edit") {
      const c1 = where("rated", "==", rated);
      const c3 = limit(10);
      qRef = query(cRef, c0, c1, c2, c3);
    }

    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        const mergered = renderMerged({ data });
        const speakers = renderSpeakers({ data: mergered });
        setDraftDialogAllSuccess(dispatch, data);
        setDraftDialogMergeRawSuccess(dispatch, mergered);
        setDraftDialogSpeakersRawSuccess(dispatch, speakers);

        if (callback) {
          callback();
        }
      }
    });
    allDraftDialogSub.push(unsub);
  };

export const unSnapDraftDialog = () => (dispatch) => {
  allDraftDialogSub.forEach((subscriber) => {
    subscriber();
  });
  allDraftDialogSub.length = 0;
};

const renderSpeakers = ({ data }) => {
  const result = lodash.cloneDeep(data) || [];
  const speakers = result?.map((r) => r?.speaker);
  const uniqSpeaker = lodash.uniq(speakers);
  const remap = uniqSpeaker?.map((u, index) => {
    const first = result?.find((r) => r?.speaker === u);
    return {
      key: u,
      label: u,
      from: first?.from,
      to: first?.to,
      color: COLOR_SPEAKER[index] || "#3B82F6",
    };
  });
  return remap;
};

const renderMerged = ({ data }) => {
  let result = [];
  const datas = lodash.cloneDeep(data) || [];
  datas?.forEach((item, dIndex) => {
    const bailiff = item?.bailiff;
    const id = item?.id;
    const combine = refineDataForVisualize(item);
    const remapCombine = combine?.map((c, index) => ({
      ...c,
      bailiff,
      segId: id + "." + dIndex + "." + index,
      id,
    }));
    result.push(...remapCombine);
  });

  return result;
};

// snap detail dialog
const allDraftDialogDetailSub = [];
export const snapDraftDialogDetail =
  ({ dialogId }, callback) =>
  (dispatch) => {
    setDraftDialogDetailSuccess(dispatch, null);
    const cRef = getRefs().dialog;
    const dRef = doc(cRef, dialogId);
    const unsub = onSnapshot(dRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.data();

        setDraftDialogDetailSuccess(dispatch, data);

        // bactch data cho effect.
        const refine = refineDataForTimeline(data);
        setDraftDialogEditorDataSuccess(dispatch, refine);
        if (callback) {
          callback();
        }
      }
    });
    allDraftDialogDetailSub.push(unsub);
  };

export const unSnapDraftDialogDetail = () => (dispatch) => {
  allDraftDialogDetailSub.forEach((subscriber) => {
    subscriber();
  });
  allDraftDialogDetailSub.length = 0;
};

// refine data for visualize.
export const refineDataForVisualize = (data) => {
  let result = lodash.cloneDeep(data) || [];
  const sentences = result?.sentences || [];
  const inserts = result?.inserts || [];
  const deletes = result?.deletes || [];

  const filterSens =
    sentences?.filter((s) => !deletes?.includes(s?.slot)) || [];
  const sums = [...filterSens, ...inserts];
  const sortSum = lodash.orderBy(sums, ["start"], ["asc"]);
  return sortSum;
};

const refineDataForTimeline = (data) => {
  let result = [];

  const sortSum = refineDataForVisualize(data);

  const group = lodash.groupBy(sortSum, "speaker");
  result = Object.entries(group)?.map(([key, value], index0) => {
    const id = key;
    const actions = value?.map((v, index) => ({
      ...v,
      id: `action_${index0}_${index}`,
      start: v?.fixStart || v?.start,
      end: v?.fixEnd || v?.end,
      speaker: `speaker${index0}`,
      color: `black`,
      bgColor: "#f1f1f1",
      content: v?.fix || v?.text,
    }));

    return {
      id,
      color: `black`,
      bgColor: "#f1f1f1",
      actions,
    };
  });

  return result;
};

// ========= cloud function =========//
// :::: sửa đoạn văn :::::://
export const fixSentences =
  ({ id, slot, text, start, end, speaker }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.fixSentences;
    const options = { id, slot, text, start, end, speaker };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// :::: pass đoạn văn :::::://
export const passQC =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.passQC;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// :::: fail đoạn văn :::::://
export const denyQC =
  ({ id, reason }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.denyQC;
    const options = { id, reason };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// :::: cảnh cáo đoạn văn :::::://
export const warnQC =
  ({ id, reason }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.warnQC;
    const options = { id, reason };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// :::: tổ hợp xử lý đoạn văn :::::://

export const cloudSaveDraftDialog =
  ({ id, CAU, rSens, rIns }, callback) =>
  async (dispatch) => {
    // promisses trả về tạo và update.
    const pCreateAndUpdate = await handleCreateAndUpdate({ id, CAU });
    // promisses trả về khi xoá sentens
    const pRemoveSens = await handleRemoveSens({ id, rSens });
    // promisses trả về khi xoá inserts.
    const pRemoveIns = await handleRemoveIns({ id, rIns });
    return Promise.all([pCreateAndUpdate, pRemoveSens, pRemoveIns])
      .then(() => {
        console.log("thao tác thành công");
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };
const handleCreateAndUpdate = async ({ id, CAU }) => {
  const promissesCAU = [];

  for (const item of CAU) {
    const action = item?.action;
    const source = item?.source;
    const slot = item?.slot;
    const text = item?.text;
    const start = item?.start;
    const end = item?.end;
    const speaker = item?.speaker;
    if (action === "create" && source === "insert") {
      const pCI = await cloudAddInserts({
        id,
        slot,
        text,
        start,
        end,
        speaker,
      });
      promissesCAU.push(pCI);
    }

    if (action === "update" && source === "insert") {
      const pUCI = await cloudUpdateInserts({
        id,
        slot,
        text,
        start,
        end,
        speaker,
      });
      promissesCAU.push(pUCI);
    }

    if (action === "update" && source === "sentence") {
      const pCS = await cloudUpdateSentences({
        id,
        slot,
        text,
        start,
        end,
        speaker,
      });
      promissesCAU.push(pCS);
    }
  }

  return Promise.all(promissesCAU);
};

const handleRemoveSens = async ({ id, rSens }) => {
  const promissesSens = [];
  for (const item of rSens) {
    const slot = item;
    const pDS = await cloudDeleteSentences({ id, slot });
    promissesSens.push(pDS);
  }
  return Promise.all(promissesSens);
};

const handleRemoveIns = async ({ id, rIns }) => {
  const promissesIns = [];
  for (const item of rIns) {
    const slot = item;
    const pDI = await cloudDeleteInserts({ id, slot });
    promissesIns.push(pDI);
  }
  return Promise.all(promissesIns);
};

// 4 hàm
const cloudAddInserts = async ({ id, slot, text, start, end, speaker }) => {
  const functions = getApiFunctions().operator.addInsert;
  const options = { id, slot, text, start, end, speaker };
  return functions(options).catch((err) => console.log({ err }));
};

const cloudUpdateInserts = async ({ id, slot, text, start, end, speaker }) => {
  const functions = getApiFunctions().operator.updateInsert;
  const options = { id, slot, text, start, end, speaker };
  return functions(options).catch((err) => console.log({ err }));
};

const cloudUpdateSentences = async ({
  id,
  slot,
  text,
  start,
  end,
  speaker,
}) => {
  const functions = getApiFunctions().operator.fixSentences;
  const options = { id, slot, text, start, end, speaker };
  return functions(options).catch((err) => console.log({ err }));
};

const cloudDeleteSentences = async ({ id, slot }) => {
  const functions = getApiFunctions().operator.addDelete;
  const options = { id, slot };
  return functions(options).catch((err) => console.log({ err }));
};

const cloudDeleteInserts = async ({ id, slot }) => {
  const functions = getApiFunctions().operator.removeInsert;
  const options = { id, slot };
  return functions(options).catch((err) => console.log({ err }));
};

export const cloudRemoveDelete = async ({ id, slot }) => {
  const functions = getApiFunctions().operator.removeDelete;
  const options = { id, slot };
  return functions(options).catch((err) => console.log({ err }));
};

// ========= storage =========//
export const getAudioUrl =
  ({ bailiff, part }) =>
  (dispatch) => {
    setDraftDialogAudioUrlSuccess(dispatch, null);
    const path = `bailiff/audio/${bailiff}/parts/${part}.mp3`;
    const storageRef = ref(storage, path);
    getDownloadURL(storageRef)
      .then((url) => {
        setDraftDialogAudioUrlSuccess(dispatch, url);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

// ========= local function =========//
export const setDraftDialogAll = (data, callback) => (dispatch) => {
  setDraftDialogAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenAdd = (data, callback) => (dispatch) => {
  setDraftDialogOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenEdit = (data, callback) => (dispatch) => {
  setDraftDialogOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenForward = (data, callback) => (dispatch) => {
  setDraftDialogOpenForwardSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSelected = (data, callback) => (dispatch) => {
  setDraftDialogSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSearch = (data, callback) => (dispatch) => {
  setDraftDialogSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenDeny = (data, callback) => (dispatch) => {
  setDraftDialogOpenDenySuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenWarn = (data, callback) => (dispatch) => {
  setDraftDialogOpenWarnSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogPlay = (data, callback) => (dispatch) => {
  setDraftDialogPlaySuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSecond = (data, callback) => (dispatch) => {
  setDraftDialogSecondSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogKick = (data, callback) => (dispatch) => {
  setDraftDialogKickSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenAdvance = (data, callback) => (dispatch) => {
  setDraftDialogOpenAdvanceSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogEditorEdit = (data, callback) => (dispatch) => {
  setDraftDialogEditorEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSpeakerColor = (data, callback) => (dispatch) => {
  setDraftDialogSpeakerColorSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSpeakerName = (data, callback) => (dispatch) => {
  setDraftDialogSpeakerNameSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogAdvanceScale = (data, callback) => (dispatch) => {
  setDraftDialogAdvanceScaleSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogAdvanceSelected = (data, callback) => (dispatch) => {
  console.log({ data });
  setDraftDialogAdvanceSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogAdvanceUndo = (data, callback) => (dispatch) => {
  let result = lodash.cloneDeep(data);
  setDraftDialogAdvanceUndoSuccess(dispatch, result);
  if (callback) {
    callback();
  }
};

export const setDraftDialogAdvanceSave = (data, callback) => (dispatch) => {
  setDraftDialogAdvanceSaveSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogEditCard = (data, callback) => (dispatch) => {
  setDraftDialogEditCardSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// làm một bộ crud dành riêng cho local.

// thêm 1 khúc cho 1 thằng speaker.
export const addTimelineAction =
  ({ origin, id, current = 0 }) =>
  (dispatch) => {
    let result = origin || [];
    const index0 = result?.findIndex((o) => o?.id === id) || 0;
    console.log({ index0, id, origin });
    if (index0 < 0) return;

    const actions = result?.[index0]?.actions || [];
    const index = actions?.length || 0;
    const object = {
      id: `action_${index0}_${index}`,
      start: current,
      end: current + 5,
      speaker: `speaker${index0}`,
      content: "Label Mới",
      bgColor: result?.[index0]?.bgColor || "black",
      color: result?.[index0]?.color || "white",
    };
    if (actions) {
      actions[index] = object;
    }
    setDraftDialogEditorDataSuccess(dispatch, result);
  };
// xoá 1 khúc của 1 thằng speaker.
export const removeTimelineAction =
  ({ origin, id, actionId }) =>
  (dispatch) => {
    let result = origin || [];
    const index0 = result?.findIndex((o) => o?.id === id) || 0;
    console.log({ index0, id, origin });
    if (index0 < 0) return;

    const actions = result?.[index0]?.actions || [];
    const renew = actions?.filter((o) => o?.id !== actionId) || [];
    result[index0].actions = renew;
    setDraftDialogEditorDataSuccess(dispatch, result);
  };
// cập nhật lại đúng đoạn văn của thằng action đó.
export const updateTimelineAction =
  ({ origin, id, actionId, text }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(origin) || [];
    const index0 = result?.findIndex((o) => o?.id === id) || 0;

    if (index0 < 0) return;
    const actions = result?.[index0]?.actions || [];
    const index = actions?.findIndex((o) => o?.id === actionId) || 0;
    if (index < 0) return;
    actions[index].content = text;
    setDraftDialogEditorDataSuccess(dispatch, result);
  };

// thêm speaker mới.
export const addTimelineNewSpeaker =
  ({ origin }) =>
  (dispatch) => {
    let result = lodash.cloneDeep(origin);
    const object = {
      id: moment()?.valueOf(),
      actions: [],
    };
    result.push(object);
    setDraftDialogEditorDataSuccess(dispatch, result);
  };

// xoá speaker
export const deleteTimelineSpeaker =
  ({ origin, id }) =>
  (dispatch) => {
    let result = lodash.cloneDeep(origin);
    console.log({ origin, result, id });
    const index = result?.findIndex((o) => o?.id === id) || 0;
    if (index < 0) return;
    result.splice(index, 1);
    setDraftDialogEditorDataSuccess(dispatch, result);
  };

// đổi màu speaker
export const reColorTimelineSpeaker =
  ({ origin, id, color, bgColor }) =>
  (dispatch) => {
    let result = lodash.cloneDeep(origin);
    const index = result?.findIndex((o) => o?.id === id) || 0;
    if (index < 0) return;
    result[index].color = color;
    result[index].bgColor = bgColor;

    const actions = result?.[index]?.actions || [];
    const renewActions = actions?.map((ac) => {
      return {
        ...ac,
        color,
        bgColor,
      };
    });

    result[index].actions = renewActions;

    setDraftDialogEditorDataSuccess(dispatch, result);
  };

// đổi tên speaker
export const reNameTimelineSpeaker =
  ({ origin, id, name }) =>
  (dispatch) => {
    let result = lodash.cloneDeep(origin);
    const index = result?.findIndex((o) => o?.id === id) || 0;
    if (index < 0) return;
    result[index].name = name;
    setDraftDialogEditorDataSuccess(dispatch, result);
  };

// hoàn tác
export const undoTimelineAction =
  ({ undo }) =>
  (dispatch) => {
    let result = lodash.cloneDeep(undo);
    setDraftDialogEditorDataSuccess(dispatch, result);
    setDraftDialogAdvanceUndoSuccess(dispatch, null);
  };

// cắt đoạn văn.
export const splitTimelineAction =
  ({ origin, id, second }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(origin) || [];
    const index0 = result?.findIndex((o) => o?.id === id) || 0;

    if (index0 < 0) return;
    const actions = result?.[index0]?.actions || [];
    const exist =
      actions?.find((a) => a?.start <= second && a?.end >= second) || null;
    if (!exist) return;
    const actionFrom = `action_` + `${actions?.length}_` + moment()?.valueOf();
    const fromObject = {
      start: exist?.start,
      content: exist?.content,
      bgColor: exist?.bgColor,
      color: exist?.color,
      speaker: exist?.speaker,
      slot: exist?.slot,
      id: actionFrom,
      end: second,
    };
    const actionTo =
      `action_` + `${actions?.length + 1}_` + moment()?.valueOf();
    const toObject = {
      content: exist?.content,
      bgColor: exist?.bgColor,
      color: exist?.color,
      speaker: exist?.speaker,
      end: exist?.end,
      id: actionTo,
      start: second,
    };

    // replace object to from, to object.
    const newActions =
      actions?.filter((a) => a?.start > second || a?.end < second) || [];
    newActions.push(fromObject);
    newActions.push(toObject);
    result[index0].actions = newActions;
    setDraftDialogEditorDataSuccess(dispatch, result);
  };

// làm một bộ crud dành riêng merge.

// về speaker trước.

// rename
export const renameSpeaker =
  ({ data, id, name }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.key === id) || 0;
    if (index < 0) return;
    result[index].label = name;
    setDraftDialogSpeakersSuccess(dispatch, result);
  };

// thêm
export const addSpeaker =
  ({ data, speaker }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    // const random = lodash.random(0, COLOR_SPEAKER?.length);
    const color =
      COLOR_SPEAKER?.[result.length % COLOR_SPEAKER.length] || "#3B82F6";
    const object = {
      key: `S` + moment()?.valueOf(),
      ...speaker,
      color,
    };
    result.push(object);
    setDraftDialogSpeakersSuccess(dispatch, result);
  };

// xoá
export const deleteSpeaker =
  ({ data, id }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.key === id) || 0;
    if (index < 0) return;
    result.splice(index, 1);
    setDraftDialogSpeakersSuccess(dispatch, result);
  };

// về merge sau.

// đổi speaker
export const changeSpeakerForMerge =
  ({ data, id, speaker }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.segId === id) || 0;
    if (index < 0) return;
    result[index].fixSpeaker = speaker;
    result[index].update = true;
    setDraftDialogMergeSuccess(dispatch, result);
  };

// điều chỉnh thông tin
export const changeInfoForMerge =
  ({ data, id, from, to, fix }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.segId === id) || 0;
    if (index < 0) return;
    result[index].fixFrom = from;
    result[index].fixTo = to;
    result[index].fix = fix;
    result[index].update = true;
    setDraftDialogMergeSuccess(dispatch, result);
  };

// thêm bên trên.
export const addAboveForMerge =
  ({ data, id }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.segId === id) || 0;
    if (index < 0) return;
    const current = result?.[index];
    const next = index + 1;
    // delete current?.docId;
    const { docId, ...detail } = current;

    const object = {
      ...detail,
      segId: detail?.segId + "." + moment()?.valueOf(),
      fix: "",
      add: true,
    };

    result.splice(next, 0, object);
    setDraftDialogMergeSuccess(dispatch, result);
  };

// xoá block
export const removeForMerge =
  ({ data, id }) =>
  (dispatch) => {
    let result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.segId === id) || 0;
    if (index < 0) return;
    result[index].remove = true;
    setDraftDialogMergeSuccess(dispatch, result);
  };

// hoàn trả nội dung cũ.
export const resetContentForMerge =
  ({ data, id }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const index = result?.findIndex((o) => o?.segId === id) || 0;
    if (index < 0) return;

    result[index].fixFrom = 0;
    result[index].fixTo = 0;
    result[index].fix = "";
    result[index].fixSpeaker = "";
    delete result[index].update;
    delete result[index].add;
    setDraftDialogMergeSuccess(dispatch, result);
  };

// hàm comments
export const addFeedback =
  ({ data, id, feedback, feedbackName }) =>
  (dispatch) => {
    const result = lodash.cloneDeep(data) || [];
    const object = {
      id,
      feedback,
      feedbackName,
    };
    console.log({ data, object });

    result.push(object);
    setDraftDialogCommentsSuccess(dispatch, result);
  };

export const removeFeedback =
  ({ data, id }) =>
  (dispatch) => {
    const filter = data?.filter((d) => d?.id !== id) || [];
    setDraftDialogCommentsSuccess(dispatch, filter);
  };

export const setDraftDialogMerge = (data) => (dispatch) => {
  setDraftDialogMergeSuccess(dispatch, data);
};

export const setDraftDialogComments = (data) => (dispatch) => {
  setDraftDialogCommentsSuccess(dispatch, data);
};

export const setDraftDialogSpeakers = (data) => (dispatch) => {
  setDraftDialogSpeakersSuccess(dispatch, data);
};

// ========= dispatch =========//

const setDraftDialogAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_ALL,
    payload: data,
  });
};

const setDraftDialogOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_ADD,
    payload: data,
  });
};

const setDraftDialogOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_EDIT,
    payload: data,
  });
};

const setDraftDialogSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SELECTED,
    payload: data,
  });
};

const setDraftDialogSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SEARCH,
    payload: data,
  });
};

const setDraftDialogDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_DETAIL,
    payload: data,
  });
};

const setDraftDialogOpenDenySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_DENY,
    payload: data,
  });
};

const setDraftDialogOpenWarnSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_WARN,
    payload: data,
  });
};

const setDraftDialogOpenForwardSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_FORWARD,
    payload: data,
  });
};

const setDraftDialogAudioUrlSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_AUDIO_URL,
    payload: data,
  });
};

const setDraftDialogPlaySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_PLAY,
    payload: data,
  });
};

const setDraftDialogSecondSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SECOND,
    payload: data,
  });
};

const setDraftDialogKickSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_KICK,
    payload: data,
  });
};

const setDraftDialogOpenAdvanceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_ADVANCE,
    payload: data,
  });
};

const setDraftDialogEditorDataSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_EDITOR_DATA,
    payload: data,
  });
};

const setDraftDialogEditorEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_EDITOR_EDIT,
    payload: data,
  });
};

const setDraftDialogSpeakerColorSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SPEAKER_COLOR,
    payload: data,
  });
};

const setDraftDialogSpeakerNameSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SPEAKER_NAME,
    payload: data,
  });
};

const setDraftDialogAdvanceScaleSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_ADVANCE_SCALE,
    payload: data,
  });
};

const setDraftDialogAdvanceSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_ADVANCE_SELECTED,
    payload: data,
  });
};

const setDraftDialogAdvanceUndoSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_ADVANCE_UNDO,
    payload: data,
  });
};

const setDraftDialogAdvanceSaveSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_ADVANCE_SAVE,
    payload: data,
  });
};

const setDraftDialogEditCardSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_EDIT_CARD,
    payload: data,
  });
};

const setDraftDialogMergeRawSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_MERGE_RAW,
    payload: data,
  });
};

const setDraftDialogMergeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_MERGE,
    payload: data,
  });
};

const setDraftDialogSpeakersSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SPEAKERS,
    payload: data,
  });
};

const setDraftDialogSpeakersRawSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SPEAKERS_RAW,
    payload: data,
  });
};

const setDraftDialogCommentsSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_COMMENTS,
    payload: data,
  });
};
